import { EventSelections } from '../types';

const STORAGE_KEY = 'eventSelections';

export const getEventSelections = (): EventSelections => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : {};
    } catch (error) {
        console.error('Error reading event selections:', error);
        return {};
    }
};

export const saveEventSelection = (eventId: string, participantId: string): void => {
    try {
        const selections = getEventSelections();
        selections[eventId] = participantId;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(selections));
    } catch (error) {
        console.error('Error saving event selection:', error);
    }
};

export const getEventSelection = (eventId: string): string | null => {
    const selections = getEventSelections();
    return selections[eventId] || null;
};

export const removeEventSelection = (eventId: string): void => {
    try {
        const selections = getEventSelections();
        delete selections[eventId];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(selections));
    } catch (error) {
        console.error('Error removing event selection:', error);
    }
};